module.exports = __webpack_public_path__ + "img/cpsPromote.4d292a9b.png";